import { MasonryEngineNodeAction } from '@leagueplatform/masonry-engine';

// Additional link types can be added to this array in the future
const linkActionTypes: string[] = ['deeplink'];

/**
 * Checks if a given Masonry Engine Node Action is a link action.
 *
 * @param {MasonryEngineNodeAction | undefined} action - The action to check.
 * @returns {boolean} True if the action is a link action, false otherwise.
 */
export const isLinkAction = (
  action: MasonryEngineNodeAction | undefined,
): boolean => Boolean(action?.type && linkActionTypes.includes(action.type));
